<template>
  <page>
    <div>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <div class="headline">Cargo Commodity Listing</div>
          <v-spacer></v-spacer>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card-title>
        <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <span slot="activator">
                {{ props.header.text }}
              </span>
              <span>
                {{ props.header.text }}
              </span>
            </v-tooltip>
          </template>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.comdty }}</td>
            <td class="text-xs-left">{{ props.item.comdtyDesc }}</td>
            <td class="text-xs-right">
              <table-action :rowData="props" :review="checkAccess(['cargoRatingReview'])" @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
            </td>
          </template>
        </v-data-table>
      </v-card>
      <div class="pt-2">
        <v-btn color="primary" @click.native="doNew()">
          New Commodity
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </div>
      <v-dialog v-model="comdtyDialog" width="800px" lazy v-if="checkAccess(['cargoRatingReview'])" persistent >
        <commodity-dialog :comdtyForm="comdtyForm" @close="doClose" :newComdty="newComdty"></commodity-dialog>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Cargo Commodity? ({{deleteCrgoComdty}})
      </confirm>
    </div>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import CommodityDialog from './CommodityDialog'

export default {
  data() {
    return {
      headers: [
        { text: 'Cargo Commodity', align: 'left', value: 'comdty' },
        { text: 'Cargo Commodity Description', align: 'left', value: 'comdtyDesc' }
      ],
      comdtyForm: {
        comdty: undefined,
        comdtyDesc: undefined
      },
      comdtyDialog: undefined,
      newComdty: undefined,
      loading: false,
      promptRemove: false,
      selectedCrgoComdty: undefined,
      deleteCrgoComdty: ''
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  methods: {
    async fetchData() {
      this.loading = true
      const apiUrl = this.$store.state.cargo.menu.getCrgoComdtys
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((CrgoComdty) => {
              const convertCrgoComdty = {
                comdty: CrgoComdty.comdty,
                comdtyDesc: CrgoComdty.comdtyDesc
              }
              this.items.push(convertCrgoComdty)
            })
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      }
    },
    async doReview(Comdty) {
      const apiURI = this.$store.state.cargo.menu.getCrgoComdty
      const expand = {
        comdty: Comdty.item.comdty
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.comdtyForm.comdty = data.comdty.comdty
          this.comdtyForm.comdtyDesc = data.comdty.comdtyDesc
        }
        this.comdtyDialog = true
      }
    },
    doClose() {
      this.comdtyDialog = false
      this.newComdty = false
      this.$validator.reset()
      this.fetchData()
    },
    doNew() {
      this.$validator.reset()
      this.comdtyDialog = true
      this.newComdty = true
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedCrgoComdty = data
        this.deleteCrgoComdty = data.comdty + ' - ' + data.comdtyDesc
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.cargo.menu.deleteComdty
      if (apiURI) {
        this.loading = true
        const expand = {
          comdty: this.selectedCrgoComdty.comdty
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          // Reinit
          this.fetchData()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  mounted() {
    // Fetch Users Data
    this.fetchData()
  },
  created() {
    if (this.checkAccess(['cargoRatingReview'])) {
      this.headers.push(TableConst.tableActionHeader)
    }
  },
  components: {
    CommodityDialog: CommodityDialog
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
